import React, { useEffect, useState, version } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";

function LedgerReport() {

    const [data, setData] = useState([]);
    const today = new Date().toISOString().split('T')[0];
    const [date, setDate] = useState(today);
    const [vehicleNum, setVehicleNum] = useState([]);
    const [selectedVnums, setSelectedVnums] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [products, setProducts] = useState([]);
    const [selectedData, setSelectedData] = useState([]);

    // console.log(selectedData);

    const formatDate = (date) => {     
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
    };

    const getData = async (approved) => {
        try {
            const response = await axios.post('https://api.trucoo.in/orders/reports/', {date}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            
            if (response.data.status === "success") {
                let report = [];

                if(approved === undefined || approved === '' || approved === null || approved === 'All'){
                    report = response.data.data; 
                }else{
                    report = response.data.data.filter(order => order?.status === approved);
                }

                // console.log("Fetched Data:", report);

                let vehicleNum = [];
                report.forEach(order => {
                    if (order.vNum && !vehicleNum.includes(order.vNum)) {
                        vehicleNum.push(order.vNum);
                    }
                });
                setVehicleNum(vehicleNum);
                setData(report || []); 
                setSelectedData(report || []);
                setDate(response.data.date);
                
            } else {
                console.log("Error fetching data");
                setData([]); 
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
            setData([]); 
        }
    };

    const handleCheckboxChange = (e) => {
        const value = e.target.value;
        const isChecked = e.target.checked;

        if (isChecked) {
        // Add the selected value
        setSelectedVnums((prev) => [...prev, value]);
        } else {
        // Remove the unselected value
        setSelectedVnums((prev) => prev.filter((v) => v !== value));
        }
    };

    const toggleDropdown = () => setIsOpen(prev => !prev);

    const selectData = () => {
        const selected = data.filter(order => selectedVnums.includes(order.vNum));
        setSelectedData(selected);

        // Build product list directly here
        let productsList = [];
        selected.forEach(order => {
            order.orderData.forEach(prod => {
            if (prod.itemCode && !productsList.find(p => p.code === prod.itemCode)) {
                productsList.push({ code: prod.itemCode, name: prod.itemName });
            }
            });
        });

        setProducts(productsList);
    };

    const getTotal = (prodCode, vnum) => {
        let totalCrates = 0;
        let totalLtrKg = 0;
        selectedData.forEach(order => {
            if (order.vNum === vnum) {
                order.orderData.forEach(prod => {
                    if (prod.itemCode === prodCode) {
                        totalCrates += parseFloat(prod.qty) || 0;
                        totalLtrKg += (parseFloat(prod.crates) * parseFloat(prod.qty) * (parseFloat(prod.weight)/1000)) || 0;
                    }
                });
            }
        });
        return { crates: totalCrates, ltrkg: totalLtrKg };
    };

    const getEdits = (vnum) => {
        let edit = false; 
        selectedData.forEach(order => {
            if (order.vNum === vnum) {
                if(order.edit === 'yes'){
                    edit = true;
                }
            }
        });
        return edit;
    };
    
    useEffect(() => {
        getData();
        setSelectedVnums(vehicleNum);
    }, [date]);

    useEffect(() => {
        selectData();
    }, [selectedVnums]);



    const downloadExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
        XLSX.writeFile(wb, `Daily-Report_${date}.xlsx`);
    };

    const downloadPDF = () => {
        const table = document.getElementById("printableArea");
        
        const originalStyles = {};
        const elements = table.querySelectorAll('*');
  
        html2canvas(table, { 
            scale: 2,
            scrollY: -window.scrollY,
        }).then((canvas) => {
            elements.forEach(el => {
                if (originalStyles[el]) {
                    el.style.cssText = originalStyles[el].cssText;
                }
            });    
            const imgData = canvas.toDataURL("image/jpeg");
            const pdf = new jsPDF("l", "mm", "a4");            
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();            
        
            const marginT = 5;
            const marginB = 10;
            const availableWidth = pdfWidth - (2 * marginT);
            const availableHeight = pdfHeight - (2 * marginB);
            
            const ratio = Math.min(availableWidth / canvas.width, availableHeight / canvas.height);
            const scaledWidth = canvas.width * ratio;
            const scaledHeight = canvas.height * ratio;
            
            pdf.addImage(imgData, "JPEG", marginT, marginB, scaledWidth, scaledHeight);
            pdf.save(`Daily-Report_${date}.pdf`);
        });
    };
    



    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Dispatch Report</h4>
                            </div>
                          
                            <div className="box-body">
                                <div className="row mb-4">
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="left">
                                        <input
                                            type="date"
                                            value={formatDate(date)}
                                            onChange={(e) => setDate(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>
                                   
                                    
                                    <div className="col-xxl-3 col-xl-3 col-lg-2 col-md-6 col-12" align="center" style={{ position: 'relative' }}>
                                        <div 
                                            className="form-control"
                                            onClick={toggleDropdown}
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                        >
                                            {selectedVnums.includes('all') ? 'All Vehicles' : 
                                             selectedVnums.length > 0 ? `${selectedVnums.length}/${vehicleNum.length} vehicles selected` : 
                                             selectedVnums.join(', ') || 'Select Vehicles'}
                                        </div>

                                        {isOpen && (
                                          <div className="dropdown-menu show" style={{ minWidth: '250px', padding: '8px', overflowY: 'auto', maxHeight: '60vh' }}>
                                            <div className="mb-2 d-flex justify-content-between align-items-center border-bottom pb-2">
                                              <strong>Select Vehicles</strong>
                                              <button className="btn btn-sm btn-light" onClick={toggleDropdown}>
                                                ×
                                              </button>
                                            </div>

                                            

                                            {/* Individual Vehicles */}
                                            {vehicleNum.map((vnum) => (
                                              <div key={vnum} className="dropdown-item py-1">
                                                <div className="form-check d-flex align-items-center">
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    style={{ opacity: 0, position: 'absolute', left: '5px'}}
                                                    id={`routeCheckbox-${vnum}`}
                                                    value={vnum}
                                                    checked={selectedVnums.includes(vnum)}
                                                    onChange={(e) => handleCheckboxChange(e)}
                                                  />
                                                  <label
                                                    className="form-check-label ms-3"
                                                    htmlFor={`routeCheckbox-${vnum}`}
                                                    style={{ paddingLeft: '24px' }}
                                                  >
                                                    {vnum}
                                                  </label>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        )}
                                    </div>

                                    

                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12" align="right">
                                        <div className="space-betwen d-flex" align="right">
                                            <div className="bg-warning" style={{width: '50px', height: '30px', borderRadius: '10px'}}></div>
                                            <p className="mt-1 m-3">Orders/Invoices have been edited.</p>
                                        </div>
                                    </div>

                                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-12" align="right">
                                        <button onClick={downloadPDF} className="btn btn-sm btn-primary mb-3 mx-2"> 
                                            <i className="fa fa-download"></i> PDF 
                                        </button>
                                        <button onClick={downloadExcel} className="btn btn-sm btn-warning mb-3"> 
                                            <i className="fa fa-download"></i> Excel 
                                        </button>
                                        
                                    </div>
                                </div>
                              
                                <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 300px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-12" id="printableArea" width='100%'>
                                        <thead>
                                             
                                             <tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                <th rowSpan={2} width="5%">Product Code</th>
                                                <th rowSpan={2}>Product Name</th>
                                                {selectedVnums?.map((vnum) => (
                                                    <th colSpan={2} key={vnum} className={`th-border-right ${getEdits(vnum) === true ? 'bg-warning' : ''}`} >{vnum}</th>
                                                ))}
                                                <th rowSpan={2}>Total Crates</th>
                                                <th rowSpan={2}>Total Litres</th>
                                            </tr>
                                            <tr className="text-dark text-center" style={{ position: 'sticky', top: 24, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                {selectedVnums?.map((vnum) => (
                                                    <React.Fragment key={vnum}>
                                                    <th>Crates</th>
                                                    <th>Litres</th>
                                                    </React.Fragment>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody class="text-end">
                                            {products?.map((prod) => {

                                                const totalsPerVehicle = selectedVnums.map((vnum) =>
                                                    getTotal(prod.code, vnum)
                                                );
                                                // Example: sum all crate totals for this product
                                                const totalCrates = totalsPerVehicle.reduce(
                                                (sum, val) => sum + (val?.crates || 0),
                                                0
                                                );

                                                // Example: sum all liters/kg totals for this product
                                                const totalLtrKg = totalsPerVehicle.reduce(
                                                (sum, val) => sum + (val?.ltrkg || 0),
                                                0
                                                );
                                                return (
                                                    <tr key={prod.code}>
                                                        <td className="text-center">{prod.code}</td>
                                                        <td className="text-start">{prod.name}</td>
                                                            {totalsPerVehicle.map((val, i) => (
                                                            <>
                                                                <td key={`${selectedVnums[i]}-crates`}>
                                                                {Number(val?.crates ?? 0).toFixed(2)}
                                                                </td>
                                                                <td key={`${selectedVnums[i]}-ltrkg`}>
                                                                {Number(val?.ltrkg ?? 0).toFixed(2)}
                                                                </td>
                                                            </>
                                                            ))}

                                                            <td>{Number(totalCrates).toFixed(2)}</td>
                                                            <td>{Number(totalLtrKg).toFixed(2)}</td>
                                                    </tr>
                                                );
                                            })}
                                       </tbody>
                                       <tfoot className="fw-bold text-end">
                                        <tr>
                                            <td colSpan={2} className="text-center">
                                                TOTAL
                                            </td>

                                            {selectedVnums?.map((vnum) => {
                                                // Sum across all products for this vehicle
                                                const vehicleTotals = products.reduce(
                                                (acc, prod) => {
                                                    const t = getTotal(prod.code, vnum);
                                                    acc.crates += t?.crates || 0;
                                                    acc.ltrkg += t?.ltrkg || 0;
                                                    return acc;
                                                },
                                                { crates: 0, ltrkg: 0 }
                                                );

                                                return (
                                                <React.Fragment key={`total-${vnum}`}>
                                                    <td>{vehicleTotals.crates.toFixed(2)}</td>
                                                    <td>{vehicleTotals.ltrkg.toFixed(2)}</td>
                                                </React.Fragment>
                                                );
                                            })}

                                            {/* Grand totals */}
                                            <td>
                                                {selectedVnums
                                                .reduce((sum, vnum) => {
                                                    return (
                                                    sum +
                                                    products.reduce(
                                                        (pSum, prod) => pSum + (getTotal(prod.code, vnum)?.crates || 0),
                                                        0
                                                    )
                                                    );
                                                }, 0)
                                                .toFixed(2)}
                                            </td>

                                            <td>
                                                {selectedVnums
                                                .reduce((sum, vnum) => {
                                                    return (
                                                    sum +
                                                    products.reduce(
                                                        (pSum, prod) => pSum + (getTotal(prod.code, vnum)?.ltrkg || 0),
                                                        0
                                                    )
                                                    );
                                                }, 0)
                                                .toFixed(2)}
                                            </td>
                                        </tr>
                                    </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {/* <Footer /> */}
        </>
    );
}

export default LedgerReport;